import { render, staticRenderFns } from "./organization-risk-detail.vue?vue&type=template&id=4b1ec6b9&scoped=true&"
import script from "./organization-risk-detail.vue?vue&type=script&lang=js&"
export * from "./organization-risk-detail.vue?vue&type=script&lang=js&"
import style0 from "./organization-risk-detail.vue?vue&type=style&index=0&id=4b1ec6b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1ec6b9",
  null
  
)

export default component.exports